
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","data-name":"Layer 1","viewBox":"0 0 1000 1000"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M668.023 270.577l-53.104 145.887-4.197 11.523-3.129 8.594-17.86 49.064L15.277 276.557l16.77-46.075 29.186-80.19h865.894l-29.205 80.19H682.596z"}}),_c('path',{attrs:{"d":"M871.785 270.577l-.12.04 5.822 15.998 17.028 46.748 34.432 94.624h-264.27l57.281-157.41z"}}),_c('circle',{attrs:{"cx":"204.406","cy":"661.865","r":"187.843"}}),_c('circle',{attrs:{"cx":"796.881","cy":"655.925","r":"187.843"}})])
          )
        }
      }
    